import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "w100" }
const _hoisted_2 = { id: "container" }
const _hoisted_3 = {
  key: 0,
  id: "main-content-port"
}
const _hoisted_4 = { class: "" }
const _hoisted_5 = { class: "w100 mb20" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_9 = { class: "w90 pad15" }
const _hoisted_10 = { class: "fl" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h5", {
  class: "fl fw600",
  style: {"width":"150px","margin-left":"5%"}
}, "一覧", -1)
const _hoisted_12 = {
  key: 0,
  class: "fl arial"
}
const _hoisted_13 = {
  class: "fs28 fw600",
  style: {"margin-left":"12px"}
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "fs11" }, "人登録済み", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_17 = {
  class: "fw400",
  style: {"margin-top":"10px"}
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("th", {
  width: "80",
  class: ""
}, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("th", { width: "320" }, [
  /*#__PURE__*/_createElementVNode("span", null, "氏名"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", { class: "fs12" }, "メールアドレス")
], -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("th", { width: "140" }, "ステータス", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("th", { width: "140" }, "役割", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("th", { width: "140" }, "外部連携", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("th", { width: "160" }, null, -1)
const _hoisted_24 = { class: "" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_26 = { class: "fs12" }
const _hoisted_27 = {
  key: 0,
  class: "fl mr10"
}
const _hoisted_28 = ["src"]
const _hoisted_29 = {
  key: 1,
  class: "fl mr10"
}
const _hoisted_30 = ["src"]
const _hoisted_31 = {
  key: 2,
  class: "fl mr10"
}
const _hoisted_32 = ["src"]
const _hoisted_33 = {
  key: 3,
  class: "fl mr10"
}
const _hoisted_34 = ["src"]
const _hoisted_35 = {
  key: 4,
  class: "fl mr10"
}
const _hoisted_36 = ["src"]
const _hoisted_37 = ["onClick"]
const _hoisted_38 = ["onClick"]
const _hoisted_39 = ["src", "onClick"]
const _hoisted_40 = { key: 1 }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue3_progress_bar = _resolveComponent("vue3-progress-bar")!
  const _component_FlashNotice = _resolveComponent("FlashNotice")!
  const _component_ChukaiSidebarMenu = _resolveComponent("ChukaiSidebarMenu")!
  const _component_MemberSettingsHeader = _resolveComponent("MemberSettingsHeader")!
  const _component_InviteMembersContent = _resolveComponent("InviteMembersContent")!
  const _component_UserIcon = _resolveComponent("UserIcon")!
  const _component_SelectTag = _resolveComponent("SelectTag")!
  const _component_ClientUserGroupsContent = _resolveComponent("ClientUserGroupsContent")!
  const _component_CustomPermissionModal = _resolveComponent("CustomPermissionModal")!
  const _component_OptionModal = _resolveComponent("OptionModal")!
  const _component_AlertModal = _resolveComponent("AlertModal")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_vue3_progress_bar),
    _createVNode(_component_FlashNotice),
    _createElementVNode("section", _hoisted_2, [
      _createVNode(_component_ChukaiSidebarMenu, { currentPage: `account` }),
      (_ctx.rm.userInfo)
        ? (_openBlock(), _createElementBlock("section", _hoisted_3, [
            _createElementVNode("section", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_MemberSettingsHeader, {
                  selectedTab: _ctx.selectedTab,
                  onSelectTab: _ctx.selectTab,
                  ref: "header"
                }, null, 8, ["selectedTab", "onSelectTab"])
              ]),
              _hoisted_6,
              (_ctx.selectedTab == 'members')
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createVNode(_component_InviteMembersContent, {
                      ref: "InviteContent",
                      users: _ctx.users,
                      canUseCustomPermissions: _ctx.canUseCustomPermissions,
                      type: `my_ug`,
                      onUpdateUsers: _ctx.updateUsers
                    }, null, 8, ["users", "canUseCustomPermissions", "onUpdateUsers"]),
                    _hoisted_8,
                    _createElementVNode("section", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _hoisted_11,
                        (_ctx.users)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                              _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.users.length), 1),
                              _hoisted_14,
                              _hoisted_15
                            ]))
                          : _createCommentVNode("", true),
                        _hoisted_16
                      ]),
                      _createElementVNode("table", _hoisted_17, [
                        _hoisted_18,
                        _hoisted_19,
                        _hoisted_20,
                        _hoisted_21,
                        _hoisted_22,
                        _hoisted_23,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user, index) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: `${index}${user.user_group_role}${_ctx.systemUpdatedAt}`,
                            class: "with_shadow",
                            style: {"height":"60px","border":"1px solid #ededed","box-shadow":"1px 1px 1px rgba(0, 0, 0, 0.2)"}
                          }, [
                            _createElementVNode("td", _hoisted_24, [
                              _createVNode(_component_UserIcon, {
                                member: user,
                                width: 38,
                                canEdit: false,
                                updateSelf: false,
                                showTooltip: false,
                                class: "fl mr3 ml20"
                              }, null, 8, ["member"])
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("span", null, _toDisplayString(user.name), 1),
                              _hoisted_25,
                              _createElementVNode("span", _hoisted_26, _toDisplayString(user.email), 1)
                            ]),
                            _createElementVNode("td", null, _toDisplayString(user.tutorial_phase >= 15 ? "登録済" : "未登録"), 1),
                            _createElementVNode("td", null, [
                              _createVNode(_component_SelectTag, {
                                name: "select_user_role",
                                id: `select_user_role${index}`,
                                class: "fl fs13 roundForm",
                                style: {"min-width":"130px","height":"50px","border":"0"},
                                options: _ctx.SelectUtil.selectUserGroupRoles,
                                defaultOption: 
                                                user.user_group_role == 1
                                                    ? `メンバー`
                                                    : user.user_group_role == 100
                                                    ? `管理者`
                                                    : `カスタム`
                                            ,
                                returnVal: `${index}`,
                                onSelectValue: _ctx.selectUserRole
                              }, null, 8, ["id", "options", "defaultOption", "returnVal", "onSelectValue"])
                            ]),
                            _createElementVNode("td", null, [
                              (user.did_connect_google_cal)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                    _withDirectives(_createElementVNode("img", {
                                      src: _ctx.$getAssetImageUrl(`/assets/buttons/google_icon.png`),
                                      width: "24"
                                    }, null, 8, _hoisted_28), [
                                      [_directive_tooltip, `${user.calendar_account_name}`]
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (user.did_connect_ms_cal)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                    _withDirectives(_createElementVNode("img", {
                                      src: _ctx.$getAssetImageUrl(`/assets/buttons/microsoft_icon.png`),
                                      width: "24"
                                    }, null, 8, _hoisted_30), [
                                      [_directive_tooltip, `${user.calendar_account_name}`]
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (user.zoom_account)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                    _withDirectives(_createElementVNode("img", {
                                      src: _ctx.$getAssetImageUrl(`/assets/logo/zoom_square.png`),
                                      width: "24"
                                    }, null, 8, _hoisted_32), [
                                      [_directive_tooltip, `${user.zoom_account.email}`]
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (user.teams_account)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                    _withDirectives(_createElementVNode("img", {
                                      src: _ctx.$getAssetImageUrl(`/assets/logo/microsoft-teams.svg`),
                                      width: "24"
                                    }, null, 8, _hoisted_34), [
                                      [_directive_tooltip, `${user.teams_account.email}`]
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (user.otp_required_for_login)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                    _withDirectives(_createElementVNode("img", {
                                      src: _ctx.$getAssetImageUrl(`/assets/icons/key.png`),
                                      width: "24"
                                    }, null, 8, _hoisted_36), [
                                      [_directive_tooltip, `二段階認証設定済`]
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("td", null, [
                              (user.tutorial_phase < 20)
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    style: {"text-decoration":"underline"},
                                    class: "lgrey pointer fw400",
                                    onClick: ($event: any) => (_ctx.resendInviteMail(user))
                                  }, "招待を再送信", 8, _hoisted_37))
                                : _createCommentVNode("", true),
                              (user.user_group_role == -1)
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 1,
                                    style: {"text-decoration":"underline"},
                                    class: "grey fs11 pointer fw400",
                                    onClick: ($event: any) => (_ctx.checkCustomDetail(user))
                                  }, "カスタム権限を確認", 8, _hoisted_38))
                                : _createCommentVNode("", true),
                              _withDirectives(_createElementVNode("img", {
                                src: _ctx.$getAssetImageUrl(`/assets/icons/trash.png`),
                                width: "16",
                                height: "19",
                                class: "pointer fr",
                                style: {"margin-right":"40px"},
                                onClick: ($event: any) => (_ctx.alertDeleteUser(user))
                              }, null, 8, _hoisted_39), [
                                [
                                  _directive_tooltip,
                                  `アカウントを削除`,
                                  void 0,
                                  { top: true }
                                ]
                              ])
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ]))
                : (_ctx.selectedTab == 'client_user_groups')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                      _createVNode(_component_ClientUserGroupsContent, {
                        ref: "ClientUserGroupsContent",
                        onShowUnlinkGroupModal: _ctx.showUnlinkGroupModal
                      }, null, 8, ["onShowUnlinkGroupModal"])
                    ]))
                  : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      _hoisted_41
    ]),
    _createVNode(_component_CustomPermissionModal, {
      currentMember: _ctx.invitedUser,
      action: _ctx.action,
      onDidChange: _ctx.didChangePermissions,
      onChangePermissions: _ctx.changePermissions
    }, null, 8, ["currentMember", "action", "onDidChange", "onChangePermissions"]),
    _createVNode(_component_OptionModal, {
      ref: "OptionModal",
      eventName: _ctx.optionEventName,
      onClickOK: _ctx.clickOK,
      onClickCancel: _ctx.clickCancel
    }, null, 8, ["eventName", "onClickOK", "onClickCancel"]),
    _createVNode(_component_AlertModal, {
      ref: "AlertModal",
      title: _ctx.alertModalDic.title,
      text: _ctx.alertModalDic.text,
      okButtonName: _ctx.alertModalDic.okButtonName,
      eventName: `delete_ug_member`,
      hideCancelButton: false,
      imageLargeUrl: null,
      height: 260,
      onClickOK: _ctx.deleteUser,
      onClickCancel: _ctx.hideAlertModal
    }, null, 8, ["title", "text", "okButtonName", "onClickOK", "onClickCancel"])
  ]))
}